export const SET_THEME = 'SET_THEME';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_LOADER = 'SET_LOADER';
export const SET_INSURANCE = "SET_INSURANCE";
 